import { BaseState, StateManager } from '@app/store/shared';
import { createReducer, on } from '@ngrx/store';
import { achievementActions } from '../actions/achievement.actions';
import { Achievement, AchievementLatest } from '../models';

export interface AchievementState {
    next: BaseState<Achievement>;
    latest: BaseState<AchievementLatest[]>;
}

const initialState: AchievementState = {
    next: StateManager.initial(),
    latest: StateManager.initial(),
};

export const achievementReducer = createReducer(
    initialState,

    on(
        achievementActions.getLatestAchievements,
        (state): AchievementState => ({
            ...state,
            latest: StateManager.setLoading(state.latest),
        }),
    ),
    on(
        achievementActions.getLatestAchievementsSuccess,
        (state, { achievements }): AchievementState => ({
            ...state,
            latest: StateManager.setLoaded(state.latest, achievements),
        }),
    ),
    on(
        achievementActions.getLatestAchievementsError,
        (state): AchievementState => ({
            ...state,
            latest: StateManager.setError(state.latest),
        }),
    ),

    on(
        achievementActions.getNextAchievement,
        (state): AchievementState => ({
            ...state,
            next: StateManager.setLoading(state.next),
        }),
    ),
    on(
        achievementActions.getNextAchievementSuccess,
        (state, { achievement }): AchievementState => ({
            ...state,
            next: StateManager.setLoaded(state.next, achievement),
        }),
    ),
    on(
        achievementActions.getNextAchievementError,
        (state): AchievementState => ({
            ...state,
            next: StateManager.setError(state.next),
        }),
    ),

    on(
        achievementActions.clear,
        (): AchievementState => ({
            ...initialState,
        }),
    ),
);
